import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { currencify } from "../../helpers/common";
import { CreditCardReportItem, CreditCardReportType } from "../../models/reports.model";
import { Router } from "@angular/router";
import { ViewAsService } from '../../services/view-as.service';
import { map } from 'rxjs/operators';
import { showSnackbar } from "../../../../../common/src/lib/components/snackbar/snackbar.component";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";

@Component({
  selector: 'app-credit-card-report-tile',
  templateUrl: './credit-card-report-tile.component.html',
  styleUrls: ['./credit-card-report-tile.component.scss']
})
export class CreditCardReportTileComponent {

  protected readonly currencify = currencify;

  @Input() item!: CreditCardReportItem;
  @Input() kind!: CreditCardReportType;

  @HostBinding('attr.id') id!: string;

  readonly$ = this.viewAsService.readonly$;

  expanded = false;

  get dividerNeed() {
    const hostElement = this.el.nativeElement;

    if (!hostElement) {
      return false;
    }

    let nextNode = hostElement.nextSibling;

    // IMPORTANT: Skip over text nodes (whitespace between elements in HTML) and comments
    // These are often present in the DOM but are not actual elements you care about.
    while (nextNode && (nextNode.nodeType === Node.TEXT_NODE || nextNode.nodeType === Node.COMMENT_NODE)) {
      nextNode = nextNode.nextSibling;
    }

    // If there's no next element, no divider is needed
    if (!nextNode) {
      return false;
    }

    // A divider is needed ONLY if the next significant DOM element is another tile component.
    // This implicitly means if the next element is a date divider, we won't add our tile divider.
    return nextNode.nodeName === 'APP-CREDIT-CARD-REPORT-TILE';
  }

  get isChargeback() {
    return this.kind === 'chargeback' || this.kind === 'pre-chargeback' || this.kind === 'settled' && (this.item.kind === 'charged-back' || this.item.kind === 'resolved');
  }

  constructor(
    private router: Router,
    private viewAsService: ViewAsService,
    private snackbar: MatSnackBar,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.id = `${this.item.wId}_${this.item.paymentId}_${this.item.id}`;
  }

  async openPayment(wId: number, pId: number) {
    await this.router.navigate([`/payments/${wId}/${pId}`]);
  }

  copyTransactionId(e: Event) {
    e?.stopPropagation();
    e?.preventDefault();
    navigator.clipboard.writeText(this.item.transactionId!).then(() => {
      showSnackbar(this.snackbar, { message: 'Copied to clipboard', duration: 1000 });
    });
  }

  toggleExpand() {
    this.expanded = !this.expanded;
  }

  getTransactionIdMask(fullId?: string) {
    if (!fullId)
      return '';

    return `*******${fullId.slice(-4)}`;
  }
}
